module.exports = {
	"$schema": "http://json-schema.org/draft-04/schema#",
	"title": "Filter Options Response",
	"description": "The filter options response object",
	"definitions": {
		"focusAsset": {
			"type": "object",
			"required": [
				"name"
			],
			"properties": {
				"name": {
					"type": "string"
				},
				"items": {
					"$ref": "#/definitions/focusAssetObject"
				}
			}
		},
		"focusAssetObject": {
			"type": "object",
			"patternProperties": {
				"\\d+-\\d+": {
					"$ref": "#/definitions/focusAsset"
				}
			}
		}
	},
	"type": "object",
	"required": [
		"currency",
		"issuer",
		"focusAsset",
		"focusCurrency",
		"focusRegion"
	],
	"properties": {
		"currency": {
			"type": "object",
			"patternProperties": {
				".+": {
					"type": "string"
				}
			}
		},
		"issuer": {
			"type": [
				"object",
				"array"
			],
			"patternProperties": {
				"\\d+": {
					"type": "string"
				}
			}
		},
		"focusAsset": {
			"$ref": "#/definitions/focusAssetObject"
		},
		"focusCurrency": {
			"type": "object",
			"patternProperties": {
				"\\d+": {
					"type": "string"
				}
			}
		},
		"focusRegion": {
			"type": "object",
			"patternProperties": {
				"\\d+": {
					"type": "string"
				}
			}
		}
	}
}